import isBefore from 'date-fns/isBefore';
import lastDayOfMonth from 'date-fns/lastDayOfMonth';

export const validateExpiration = (
  expMonth: string | number,
  expYear: string | number,
  bookingDate: Date
) => {
  const expirationDate = lastDayOfMonth(new Date(+expYear, +expMonth - 1));
  return isBefore(bookingDate, expirationDate);
};
